import { createContext, useContext } from 'react';

type CourseraPlusUserContextType = {
  ownsCourseraPlus?: boolean;
  ownsCourseraLite?: boolean;
};

const CourseraPlusUserContext = createContext<CourseraPlusUserContextType>({
  ownsCourseraPlus: false,
  ownsCourseraLite: false,
});

export const useCourseraPlusUserData = () => useContext(CourseraPlusUserContext);

export default CourseraPlusUserContext;
